import type { User } from 'oidc-client-ts';
import { IntlProvider } from 'react-intl';
import { RouterProvider } from 'react-router-dom';

import { ErrorBoundary } from './components/ErrorBoundary';
import ErrorFallback from './components/error/ErrorFallback';
import { InvalidLogin } from './components/error/InvalidLogin';
import { DEFAULT_LOCALE } from './configuration/lang/lang';
import { getDisplayMessages, getLocale } from './configuration/lang/langSlice';
import { isAzureLogin, isHelpGangRoute, isRioPlatformLogin } from './configuration/setup/helpgangDetector';
import { useAppSelector } from './configuration/setup/hooks';
import { router } from './routes/Router';

export const App = ({ user }: { user: User | null }) => {
    const userLocale = useAppSelector(getLocale);
    const displayMessages = useAppSelector(getDisplayMessages);

    if (!(displayMessages && userLocale)) {
        return null;
    }

    try {
        if (isHelpGangRoute()) {
            if (isRioPlatformLogin((user as User).profile.sub)) {
                return <InvalidLogin idToken={user?.id_token} loginType={'rio'} />;
            }
        } else {
            if (isAzureLogin((user as User).profile.sub)) {
                return <InvalidLogin idToken={user?.id_token} loginType={'azure'} />;
            }
        }
    } catch (e) {
        console.error(e);
    }

    return (
        <IntlProvider defaultLocale={DEFAULT_LOCALE} key={userLocale} locale={userLocale} messages={displayMessages}>
            <ErrorBoundary fallback={<ErrorFallback />}>
                <RouterProvider router={router} />
            </ErrorBoundary>
        </IntlProvider>
    );
};
